import { mapState, mapActions, mapGetters } from 'vuex'
import { addMinutesToDate } from '@/utils/utils'
export var ifoodMixin = {
  data() {
    return {
      switchTheme: false,
      titleIfood: 'Pago via iFood',
      titleCustomer: 'Cobrar do Cliente',
      subtitleIfood:
        'O iFood já recebeu este valor e vamos repassar a sua loja',
      subtitleCustomer: 'O entregador deve cobrar este valor no ato da entrega',
      sponsors: [
        { id: 'IFOOD', title: 'iFood' },
        { id: 'MERCHANT', title: 'Parceiro' },
      ],

      actionButtons: [
        {
          id: 'confirm',
          title: 'Confirmar Pedido',
          icon: 'mdi-check',
          class: 'red white--text mr-1 text-caption',
          action: 'confirmOrder',
          conditionType: 'PLC',
          orderType: ',TAKEOUT,DELIVERY,INDOOR,',
          visible: true,
        },
        {
          id: 'start',
          title: 'Iniciar Preparo Pedido',
          icon: 'mdi-food-turkey',
          class: 'warning white--text mr-1',
          action: 'startPreparationOrder',
          conditionType: 'CFM',
          orderType: ',TAKEOUT,DELIVERY,INDOOR,',
          visible: false, // este botão está bloqueado por iniciar preparo automatico backend
        },
        {
          id: 'ready',
          title: 'Retirar Pedido',
          icon: 'mdi-store',
          class: 'indigo white--text mr-1',
          action: 'readyToPickupOrder',
          conditionType: 'CFM',
          orderType: ',TAKEOUT,INDOOR,',
          visible: true,
        },
        {
          id: 'dispatch',
          title: 'Despachar Pedido',
          icon: 'mdi-moped-outline',
          class: 'success white--text mr-1',
          action: 'dispatchOrder',
          conditionType: 'CFM',
          orderType: ',DELIVERY,',
          visible: true,
        },
        {
          id: 'acceptCancellation',
          title: 'Aceitar Cancelamento Pedido',
          icon: 'mdi-thumb-up-outline',
          class: 'success white--text mr-1',
          action: 'acceptCancellation',
          conditionType: 'CCR',
          orderType: ',TAKEOUT,DELIVERY,INDOOR,',
          visible: true,
        },
        {
          id: 'denyCancellation',
          title: 'Negar Cancelamento Pedido',
          icon: 'mdi-thumb-down-outline',
          class: 'error white--text mr-1',
          action: 'denyCancellation',
          conditionType: 'CCR',
          orderType: ',TAKEOUT,DELIVERY,INDOOR,',
          visible: true,
        },
      ],
    }
  },
  computed: {
    ...mapState('ifoodModule', ['orderPolling', 'canceledCodes']),
    ...mapGetters({
      itemsTipoPrevisaoList: 'ifoodModule/getItemsTipoPrevisao',
    }),

    cmpTipoPrevisaoEntrega() {
      return this.orderPolling
        ? this.itemsTipoPrevisaoList.filter(
            (v) => v.value == this.orderPolling.orderType
          )[0]
        : ''
    },

    cmpCustomerInfoText() {
      const primeiro = this.$t('ifood.primeiro')
      if (!this.orderPolling)
        return this.$t('ifood.pedidoLoja', { quantidade: primeiro })

      const orderCount = this.orderPolling.customer.ordersCountOnMerchant

      return this.$t('ifood.pedidoLoja', {
        quantidade: orderCount > 0 ? orderCount : primeiro,
      })
    },

    cmpPaymentInfoText() {
      const payments = this.orderPolling.payments

      var lines = []
      payments.methods.forEach((payment) => {
        let obj = {
          message: {
            brand: this.getBrand(payment),
            title: payment.prepaid ? this.titleIfood : this.titleCustomer,
            subtitle: payment.prepaid
              ? this.subtitleIfood
              : this.subtitleCustomer,
          },
          type: this.getPaymentTypeDescription(payment),
          value: payment.value * (payment.prepaid ? -1 : 1),
          options: null,
        }
        if (payment.method == 'CASH') obj.options = this.getCashInfo(payment)
        lines.push(obj)
      })

      return lines
    },

    cmpDeliveryTimeText() {
      return this.getDeliveryTimeText(this.orderPolling)
    },
  },
  methods: {
    ...mapActions({
      // Loading Dialog Module
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
    }),
    getInfoTopCard(event) {
      // let message = ''
      let info = { message: '' }
      switch (event.code) {
        case 'CFM':
          info = {
            message: 'Em preparo',
            icon: 'mdi-food-turkey',
            color: 'orange',
          }
          break
        case 'DSP':
          info = {
            message: 'Em entrega',
            icon: 'mdi-racing-helmet',
            color: 'green',
          }
          break
        case 'RTP':
          info = {
            message: 'Pronto para Retirar',
            icon: 'mdi-food-turkey',
            color: 'green',
          }
          break
        case 'CON':
          info = {
            message: 'Concluído',
            icon: 'mdi-package-variant-closed-check',
            color: 'green',
          }
          break
        case 'CAN':
        case 'CAR':
        case 'CCR':
        case 'CCA':
        case 'CCD':
          info = {
            message: 'Cancelado',
            color: 'red',
            icon: 'mdi-alert',
            warningMessage: 'Verifique cancelamento pedido Gestão',
            reasonMessage:
              event.metadata.CANCEL_REASON ?? 'Verifique motivo no log.',
          }
          break
        default:
          if (event.order.orderTiming == 'SCHEDULED' && event.isWait) {
            info = {
              message: this.getDeliveryTimeText(event.order),
            }
          } else info = { message: 'Pendente' }
          break
      }
      return info
    },

    getExpirationTime(event) {
      /**
       *  Limites
       *   Pedidos IMMEDIATE: até 8 minutos após a data do pedido (createdAt)
       *   Pedidos SCHEDULED: até 8 minutos após o horário de início do preparo (preparationStartDateTime)
       *
       *   Pedidos imediatos não tem diferença de data
       *   "createdAt": "2022-07-12T19:59:33.027Z",
       *   "preparationStartDateTime": "2022-07-12T19:59:33.027Z",
       */

      const now = new Date()
      var createdAt = null
      if (event.code == 'PLC') {
        createdAt = new Date(event.order.preparationStartDateTime)
      } else {
        createdAt = new Date(event.createdAt)
      }
      var diferenca = new Date(now - createdAt)
      const time = {
        hour: diferenca.getUTCHours(),
        minute: diferenca.getUTCMinutes(),
      }

      return time
    },

    getDeliveryTimeText(order) {
      if (!order) return 'Teste Entrega Prevista: 21/06/2000 11:50 - 12:20'

      let data = { dateStart: null, dateFinish: null, text: null }

      if (order.orderType == 'TAKEOUT') {
        data.dateStart = order.takeout.takeoutDateTime
        data.text = 'Retirada prevista: '
      } else {
        data.dateStart = order.delivery.deliveryDateTime
        data.text = 'Entrega prevista: '
      }

      if (order.orderTiming == 'SCHEDULED') {
        data.text = 'Agendado para: '

        // vai diminuir 30 minutos do tempo final IGUAL IFOOD
        data.dateStart = addMinutesToDate(
          order.schedule.deliveryDateTimeEnd,
          -30
        )
        data.dateFinish = order.schedule.deliveryDateTimeEnd
      }

      return this.formatDescriptionDelivery(data)
    },

    getCashInfo(method) {
      if (!method.method == 'CASH') return null

      let messages = []

      const value =
        method.cash && method.cash.changeFor > 0
          ? method.cash.changeFor
          : method.value

      messages.push('Valor a receber em dinheiro: R$ ' + value.toFixed(2))

      const diff = value - method.value

      if (diff > 0)
        messages.push('Valor para levar de troco: R$ ' + diff.toFixed(2))

      return messages
    },
    getPaymentTypeDescription(method) {
      let message = ''
      switch (method.method) {
        case 'CREDIT':
          message = 'Crédito  - '
          break
        case 'DEBIT':
          message = 'Débito  - '
          break
        case 'MEAL_VOUCHER':
          message = 'Refeição - '
          break
        case 'FOOD_VOUCHER':
          message = 'Cartão iFood - '
          break
        case 'DIGITAL_WALLET':
          message = 'Carteira Digital ' + method.wallet.name + ' - '
          break
        case 'BANK_DRAFT':
          message = 'Cheque - '
          break
        default:
          message = 'Dinheiro '
          break
      }

      if (method.card) message += method.card.brand
      message += method.prepaid ? ' via iFood' : ' via loja'

      return message
    },
    getFormattedAddress(addressInfo) {
      const {
        formattedAddress,
        neighborhood,
        city,
        postalCode,
        complement,
      } = addressInfo

      return `${formattedAddress} - ${neighborhood ??
        ''} - ${city} ● CEP ${postalCode} - ${complement ?? ''}`
    },
    formatDescriptionDelivery(dates) {
      let fmtDate = new Date(dates.dateStart).toLocaleDateString('pt-BR')
      let timeStart = new Date(dates.dateStart).toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      })
      let timeFinish = dates.dateFinish
        ? new Date(dates.dateFinish).toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
          })
        : ''

      return `${dates.text} ${fmtDate} ${timeStart} ${timeFinish}`
    },

    getBrand(methods) {
      const brand = methods.card ? methods.card.brand : methods.method

      const brands = [
        {
          id: 'amex',
          title: 'American Express',
          flagSrc: '/images/logo/amex.png',
        },
        {
          id: 'mastercard',
          title: 'MasterCard',
          flagSrc: '/images/logo/mastercard.png',
        },
        {
          id: 'visa',
          title: 'Visa',
          flagSrc: '/images/logo/visa.png',
        },
        {
          id: 'CASH',
          title: 'Dinheiro',
          flagSrc: '/images/logo/money.png',
        },
        {
          id: 'BANK_DRAFT',
          title: 'Cheque',
          flagSrc: '/images/logo/money.png',
        },
      ]

      return brands.filter((b) => b.id === brand.toLowerCase())[0]
    },
  },
}
